import React, { useContext, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import AppContext from 'context/Context';
import DatePicker from 'react-datepicker';
import EventService from './EventService';
import Select from 'react-select';
import DirectoryService from '../directory/DirectoryService';
import moment from 'moment';
import { useMsal } from '@azure/msal-react';
import { Alert } from 'react-bootstrap';
import { users } from 'data/dashboard/default';
import { faRobot } from '@fortawesome/free-solid-svg-icons'
import PredictedCostModal from './PredictedCostModal';
const AddScheduleModal = ({
  setIsOpenScheduleModal,
  isOpenScheduleModal,
  setInitialEvents,
  initialEvents,
  scheduleStartDate,
  setScheduleStartDate,
  scheduleEndDate,
  setScheduleEndDate
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const [formData, setFormData] = useState({});
  const [attendees, setAttendees] = useState([]);
  const [videoConferenceLink, setVideoConferenceLink] = useState(false);
  const [validated, setValidated] = useState(false);
  const [labels, setLabels] = useState([]);
  const [estimatedCostByAttendant, setEstimatedCostByAttendant] = useState(0.0);
  const [estimatedCost, setEstimatedCost] = useState(null);
  const [totalHours, setTotalHours] = useState(1);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [predictedCost, setPredictedCost] = useState(null);
  const [showPredictedCost, showPredictedCostModal] = useState(false);
  const [isLoadingPrediction, setIsLoadingPrediction] = useState(false);
  const [shouldPredictCost, setShouldPredictCost] = useState(true);
  const minTime = new Date();
  const formRef = useRef(null);

  const generateTimes = () => {
    const start = new Date();
    start.setHours(8, 0, 0, 0); // 09:00
    const end = new Date();
    end.setHours(18, 0, 0, 0); // 17:00

    const times = [];
    for (let d = new Date(start); d <= end; d.setMinutes(d.getMinutes() + 30)) {
      times.push(new Date(d));
    }
    return times;
  };

  const handleClose = () => {
    setIsOpenScheduleModal(!isOpenScheduleModal);
  };
  const handleCloseForPredictedCost = () => {
    showPredictedCostModal(false);
  };
  const handleConfirm = () => {
    showPredictedCostModal(false);
    const updatedFormData = {
      ...formData,
      estimatedCost: predictedCost.total_cost
    };
    setFormData(updatedFormData);

    // Trigger form submission programmatically
    if (formRef.current) {
      const submitEvent = new Event('submit', {
        bubbles: true,
        cancelable: true
      });
      formRef.current.dispatchEvent(submitEvent);
    }
    handleClose();
  };
  const handleReSchedule = () => {
    showPredictedCostModal(false);
    setIsOpenScheduleModal(true);
  };
  const { instance, accounts } = useMsal();

  const handleChange = ({ target }) => {
    let name = target.name;

    let value = name === 'allDay' && target.value === 'on' ? true : false;
    value = name !== 'allDay' ? target.value : value;
    //alert(target.value);
    setFormData({ ...formData, [name]: value });

    console.log(formData);
  };
  const updateAttendees = value => {
    setAttendees(value);
    setFormData({ ...formData, attendeesValues: attendees });
    //setEstimatedCostByAttendant(calculateEstimatedCost(attendees));
  };
  const calculateEstimatedCost = () => {
    if (!attendees || attendees.length === 0) return 0;

    const total = attendees.reduce((sum, a) => {
      const profile = users.find(u => u.identifier === a.value);
      const salary = Number(profile?.contract?.salaryPerHour);
      return sum + (Number.isFinite(salary) ? salary : 0);
    }, 0);

    return Number(total.toFixed(2));
  };

  const calculateTotalHours = (startDate, endDate) => {
    try {
      console.log(formData);
      if (startDate !== null && endDate !== null) {
        const totalHours = DirectoryService.diffHours(startDate, endDate, 2);

        setTotalHours(totalHours);
        console.log('Total Hours: ', totalHours);
      } else {
        setTotalHours(0.0);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const callMeetingCostPredictor = e => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    setIsLoadingPrediction(true);
    EventService.predictMeetingCost(formData)
      .then(predictedCost => {
        console.log('Predicted Meeting Cost:', predictedCost);
        setPredictedCost(predictedCost);
        showPredictedCostModal(true);
      })
      .catch(error => {
        console.error('Error predicting meeting cost:', error);
        alert('Error predicting meeting cost. Please try again.');
      })
      .finally(() => {
        setIsLoadingPrediction(false);
      });
  };
  const handleSubmit = async e => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget || formRef.current;
    setValidated(true);
    // Date validation logic
    const startDate = moment(formData.startDate, 'DD/MM/YYYY h:mm aa');
    const endDate = moment(formData.endDate, 'DD/MM/YYYY h:mm aa');

    if (endDate.isBefore(startDate)) {
      setError(
        'Please check your dates: the meeting can’t end before it starts.'
      );
      return; // Prevent the form from being submitted
    } else {
      setError(''); // Clear any previous error
    }
    if (form.checkValidity()) {
      try {
        let event;
        if (accounts.length > 0) {
          if (formData.attendeesValues !== undefined) {
            formData.attendees = formData.attendeesValues;
          }
          event = await EventService.saveAzureCalendarEvent(
            formData,
            instance,
            accounts
          );
        } else {
          event = await EventService.saveManagementEvent(formData);
        }
        setInitialEvents([...(initialEvents || []), event]);
        setIsOpenScheduleModal(false);
      } catch (error) {
        console.error('Error saving event:', error);
        // Handle the error or provide user feedback
      }
    }
  };
  const validateAttendees = () => {
    return formData.attendeesValues && formData.attendeesValues.length > 0
      ? true
      : false;
  };

  const isFormValid = () => {
    // Check if all required fields are populated
    const hasTitle = formData.title && formData.title.trim() !== '';
    const hasStartDate = formData.startDate !== null && formData.startDate !== undefined;
    const hasEndDate = formData.endDate !== null && formData.endDate !== undefined;
    const hasAttendees = formData.attendeesValues && formData.attendeesValues.length > 0;
    
    return hasTitle && hasStartDate && hasEndDate && hasAttendees;
  };

  const [attendesItems, setAttendeesItems] = useState([]);

  //setLabels(labels);
  useEffect(() => {
    if (isOpenScheduleModal) {
      console.log(scheduleStartDate);
      console.log(scheduleEndDate);
      const updatedFormData = {
        ...formData,
        start: scheduleStartDate,
        end: scheduleEndDate,
        startDate: scheduleStartDate,
        endDate: scheduleEndDate
      };

      setFormData(updatedFormData);
    } else {
      setScheduleStartDate(null);
      setScheduleEndDate(null);
    }
    DirectoryService.retrieveUsersByAccount()
      .then(usersByAccount => {
        const updatedItems = usersByAccount.map(u => ({
          //value: u.identifier !== undefined > 0 ? u.identifier : u.email,
          value: u.identifier,
          label: u.firstName + ' ' + u.lastName
        }));
        setUsers(usersByAccount);

        setAttendeesItems(updatedItems);
        const labels = [
          {
            label: 'Business',
            value: 'Business'
          },
          {
            label: 'Important',
            value: 'Important'
          },
          {
            label: 'Personal',
            value: 'Personal'
          },
          {
            label: 'Must Attend',
            value: 'Must Attend'
          }
        ];
        setLabels(labels);
      })
      .catch(error => {
        console.error('Error retrieving users:', error);
      });
  }, [isOpenScheduleModal]);

  return (
    formData && (
      <>
        <Modal
          show={isOpenScheduleModal}
          onHide={handleClose}
          contentClassName="border"
          backdrop="static"
          keyboard={false}
        >
          {' '}
          <Form
            ref={formRef}
            onSubmit={handleSubmit}
            noValidate
            validated={validated}
          >
            <Modal.Header
              closeButton
              closeVariant={isDark ? 'white' : undefined}
              className="bg-light px-card border-bottom-0"
            >
              <Modal.Title as="h5"> Create Meeting</Modal.Title>
            </Modal.Header>
            {error && (
              <Alert key="danger" variant="danger" className="m-3">
                {error}
              </Alert>
            )}
            <Modal.Body className="p-card">
              <Form.Group className="mb-3" controlId="title">
                <Form.Label>Title</Form.Label><br/>
                <Form.Control
                  type="text"
                  name="title"
                  required
                  value={formData.title || ''}
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a title for the event
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="startDate">
                <Form.Label>Start Date</Form.Label><br/>
                <DatePicker
                  selected={formData.startDate}
                  onChange={date => {
                    setScheduleStartDate(date);
                    // Calculate endDate as 30 minutes after startDate
                    const newEndDate = new Date(date);
                    newEndDate.setMinutes(newEndDate.getMinutes() + 30);
                    setScheduleEndDate(newEndDate);
                    setFormData({ 
                      ...formData, 
                      startDate: date, 
                      start: date,
                      endDate: newEndDate,
                      end: newEndDate
                    });
                    calculateTotalHours(date, newEndDate);
                  }}
                  autoComplete="off"
                  required
                  className="form-control fs--1 m-1"
                  placeholderText="DD/MM/YYYY H:M"
                  dateFormat="dd/MM/yyyy h:mm aa"
                  showTimeSelect
                  name="startDate"
                  value={formData.startDate}
                  includeTimes={generateTimes()}
                />
                <Form.Control.Feedback type="invalid">
                  Please a valide start date for the event
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="endDate">
                <Form.Label>End Date</Form.Label><br/>
                <DatePicker
                  selected={scheduleEndDate}
                  onChange={date => {
                    // Validate that endDate is not before startDate
                    if (formData.startDate && date < formData.startDate) {
                      setError('End date cannot be earlier than start date.');
                      return;
                    }
                    setError(''); // Clear error if validation passes
                    setScheduleEndDate(date);
                    setFormData({ ...formData, endDate: date, end: date });
                    calculateTotalHours(formData.start, date);
                  }}
                  autoComplete="off"
                  required
                  className="form-control fs--1 m-1"
                  placeholderText="DD/MM/YYYY H:M"
                  dateFormat="dd/MM/yyyy h:mm aa"
                  showTimeSelect
                  name="endDate"
                  value={scheduleEndDate}
                  includeTimes={generateTimes()}
                  minDate={formData.startDate}
                />
                <Form.Control.Feedback type="invalid">
                  Please a valide end date for the event
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="attendees">
                <Form.Label>Attendees</Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  options={attendesItems}
                  placeholder="Select..."
                  isMulti={true}
                  classNamePrefix="react-select"
                  value={formData.attendeesValues}
                  onChange={value => updateAttendees(value)}
                  className={validateAttendees() ? 'is-valid' : 'is-invalid'}
                />
                <Form.Control.Feedback type="invalid">
                  Please the attendees for the events
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="allDay">
                <Form.Check
                  type="switch"
                  id="allDay"
                  label="All Day"
                  name="allDay"
                  onChange={handleChange}
                />
              </Form.Group>
              {estimatedCost && (
                <Form.Group controlId="estimatedCost">
                  <Form.Label>Estimated cost</Form.Label>
                  <Form.Control
                    type="text"
                    readOnly
                    name="estimatedCost"
                    id="estimatedCost"
                    className="mb-4"
                    onChange={handleChange}
                  />
                </Form.Group>
              )}
              <Form.Group className="mb-3">
                <Form.Label>Schedule Meeting</Form.Label>
                <div>
                  {!videoConferenceLink && (
                    <Button
                      as={Link}
                      variant="link"
                      to="#!"
                      // type="button"
                      className="badge-soft-success fw-medium"
                      size="sm"
                      onClick={() => {
                        setVideoConferenceLink(true);
                      }}
                    >
                      <FontAwesomeIcon icon="video" className="me-2" />
                      <span>Add video conference link</span>
                    </Button>
                  )}
                  {videoConferenceLink && (
                    <Form.Control
                      type="text"
                      name="url"
                      onChange={handleChange}
                    />
                  )}
                </div>
              </Form.Group>

              <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  style={{ fontSize: '0.875rem' }}
                  rows={9}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="label">
                <Form.Label>Type</Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  name="label"
                  key="label"
                  options={labels}
                  placeholder="Select..."
                  required={true}
                  isMulti={false}
                  classNamePrefix="react-select"
                  value={formData.label || ''}
                  onChange={value => {
                    setValidated(true);
                    setFormData({ ...formData, label: value });
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Provide a label for the event
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="predictCost" className="mb-3">
                <Form.Check
                  type="switch"
                  id="predictCost"
                  label="Predict Cost"
                  name="predictCost"
                  checked={shouldPredictCost}
                  onChange={(e) => setShouldPredictCost(e.target.checked)}
                />
              </Form.Group>
            </Modal.Body>

            <Modal.Footer className="bg-light px-card border-top-0">
              <Button
                variant="primary"
                type="button"
                onClick={shouldPredictCost ? callMeetingCostPredictor : handleSubmit}
                className="px-4 mx-0"
                disabled={isLoadingPrediction || !isFormValid()}
                icon={faRobot}
              >
                {shouldPredictCost && <FontAwesomeIcon icon={faRobot} className="me-2" />}
                {isLoadingPrediction ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Analyzing...
                  </>
                ) : (
                  shouldPredictCost ? 'Analyse and Save' : 'Save Meeting'
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        <PredictedCostModal 
        showPredictedCost={showPredictedCost} 
        predictedCost={predictedCost} 
        handleCloseForPredictedCost={handleCloseForPredictedCost} 
        handleConfirm={handleConfirm} 
        handleReSchedule={handleReSchedule}/>
      </>
    )
  );
};

AddScheduleModal.propTypes = {
  setIsOpenScheduleModal: PropTypes.func.isRequired,
  isOpenScheduleModal: PropTypes.bool.isRequired,
  setInitialEvents: PropTypes.func,
  initialEvents: PropTypes.array,
  scheduleStartDate: PropTypes.instanceOf(Date),
  setScheduleStartDate: PropTypes.func.isRequired,
  scheduleEndDate: PropTypes.instanceOf(Date),
  setScheduleEndDate: PropTypes.func.isRequired
};

export default AddScheduleModal;
